import { useEffect, useState } from 'react'

// import { AUTH_LANGUAGE_ATTR } from '../constants/auth'

const useLanguageSelect = (
  i18n,
  languages,
  updateLanguage,
  savedLanguage = null
  // invert = false
) => {
  const [chooseLanguage, setChooseLanguage] = useState(false)
  const [language, setLanguage] = useState(savedLanguage || i18n.language)

  useEffect(() => {
    setLanguage(savedLanguage)
  }, [savedLanguage])

  const handleLanguageClick = () => {
    setChooseLanguage(true)
  }

  // const handleCancelPopup = () => {
  //   setChooseLanguage(false)
  // }

  // const handleLanguageSelect = (selectedLanguage) => {
  //   i18n.changeLanguage(selectedLanguage)
  //   setLanguage(selectedLanguage)
  //   if (savedLanguage) {
  //     updateLanguage({ [AUTH_LANGUAGE_ATTR]: selectedLanguage })
  //   }
  //   handleCancelPopup()
  // }

  const renderPopup = () => {
    if (chooseLanguage) {
      return null
      // <ChooseLanguage
      //   languages={languages}
      //   language={language}
      //   onCancel={handleCancelPopup}
      //   onSelect={handleLanguageSelect}
      //   t={t}
      //   invert={invert}
      // />
    }
  }

  return [language, handleLanguageClick, renderPopup]
}

export { useLanguageSelect }
